import Cookies from 'js-cookie'

export const TOKEN_KEY = 'auth_token'
export const REVIEW_TOKEN_KEY = 'ReviewUserWatch'
export const OPENID_KEY = 'WechatOpenId'
export const PPP_KEY = "pppKey";
export const VIEW_SOURCE_KEY = 'view_source';

export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: 14 })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) {
    if (token.length > 10) {
      return token
    } else {
      Cookies.set(TOKEN_KEY, "", { expires: 14 })
    }
  }
  return ""
}

export const setViewSource = (viewSource) => {
  sessionStorage.setItem(VIEW_SOURCE_KEY, viewSource)
}

export const getViewSource = () => {
  const viewSource = sessionStorage.getItem(VIEW_SOURCE_KEY)
  if (viewSource) return viewSource
  else return ''
}

export const getReviewToken = () => {
  const token = Cookies.get(REVIEW_TOKEN_KEY)
  if (token) return token
  else return ''
}

export const setReviewToken = (token) => {
  Cookies.set(REVIEW_TOKEN_KEY, token, { expires: 14 })
}

export const removeToken = () => {
    const token = Cookies.get(TOKEN_KEY)
    if (token) Cookies.remove(TOKEN_KEY)
}

export const setPPPKey = (token) => {
  const oneHour = new Date(new Date().getTime() + 60 * 60 * 1000);
  Cookies.set(PPP_KEY, token, { expires: oneHour })
}

export const getPPPKey = () => {
  const token = Cookies.get(PPP_KEY)
  if (token) return token
  else return ''
}

export const removePPPKey = () => {
  const token = Cookies.get(PPP_KEY)
  if (token) Cookies.remove(PPP_KEY)
}


export const getWechatOpenId = () => {
  const token = Cookies.get(OPENID_KEY)
  if (token) return token
  else return ''
}

export const setWechatOpenId = (token) => {
  Cookies.set(OPENID_KEY, token, { expires: 14 })
}

